"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_tag_1 = __importDefault(require("./get-tag"));
/**
 * Detects the type of the given value.
 *
 * @param {unknown} value - The value to check.
 * @returns {string} The type of the value.
 */
function detect(value) {
    const tag = (0, get_tag_1.default)(value);
    return tag.slice(8, -1).toLowerCase();
}
exports.default = detect;
//# sourceMappingURL=detect.js.map